const getServiceForTeam = {
  variable: [
    '$duration: Duration!',
    '$serviceReq:ServiceReq!',
    '$permissions: [String]',
  ],
  query: `
    services: getServiceForTeam(duration: $duration, serviceReq:$serviceReq, permissions: $permissions) {
      key: id
      label: name
      permissions
    }
  `,
};

const getQueryInstances = {
  variable: ['$serviceId: ID!', '$duration: Duration!'],
  query: `
    services: getServiceInstances(duration: $duration, serviceId: $serviceId) {
      key: id
      label: name
    }
  `
};

const readMetricsValues = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
    readMetricsValues: readMetricsValues(condition: $condition, duration: $duration) {
      label
      values {
        values {value}
      }
    }`
};

const heatMapValues = {
  variable: ['$condition: BrowserErrorLogQueryCondition'],
  query: `queryBrowserErrorByCountries(condition: $condition) {
      countries {
        countryCode
        errorCount
      }
    }`
   };

const heatMapValuesCompare = {
    variable: ['$condition: BrowserErrorLogQueryCondition, $conditionCompared: BrowserErrorLogQueryCondition'],
    query: `queryBrowserErrorByCountries(condition: $condition) {
        countries {
          countryCode
          errorCount
        }
}
        compared: queryBrowserErrorByCountries(condition: $conditionCompared) {
        countries {
          countryCode
          errorCount
        }
}`
  };

const getErrorLogs = {
  variable: ['$condition: BrowserErrorLogQueryCondition'],
  query: `queryBrowserErrorLogs(condition: $condition) {
    logs {
      userId
      uniqueId
      os
      device
      browser
      time
      traceId
      apmServiceTrace {
        serviceId
        serviceName
      }
      endPoints {
        key : key
        label :value
      }
      instancePoints {
        key : key
        label : value
      }
    }
    total
  }`
};

const getErrorLog = {
  variable: ['$eventId: ID!'],
  query: `queryBrowserErrorLog(eventId: $eventId) {
      userId
      uniqueId
      os
      device
      browser
      message
      service
      serviceVersion
      serviceName
      serviceVersionName
      time
      pagePath
      category
      errorUrl
      stack
      grade
      userAgent
      environment
      level
      errorName
      exception {
        type
        value
        module
        threadId
        message
        stacktrace {
          frames {
            filename
            function
            lineno
            colno
          }
        }
      }
      sdk {
        name
        version
      }
      breadcrumbs {
        type
        message
        data {
          key
          value
        }
        timestamp
        level
        category
      }
      traceId
      apmServiceTrace {
        serviceId
        serviceName
      }
      endPoints {
        key : key
        label :value
      }
      instancePoints {
        key : key
        label : value
      }
  }`
};
const getErrors = {
  variable: ['$condition: BrowserErrorLogQueryCondition'],
  query: `queryBrowserErrorSummary(condition: $condition) {
    total
    errors {
        users
        events
        lastOccurrence
        errorName
        trace
        errorLog {
      message
      
    }
    }
  }`
};
export default {
  getServiceForTeam,
  getQueryInstances,
  readMetricsValues,
  heatMapValues,
  heatMapValuesCompare,
  getErrorLogs,
  getErrorLog,
  getErrors
};
